import Button from "./Button";
import AttachFileIcon from "@mui/icons-material/AttachFile";

const ButtonUploadFile = ({ name, onClick }) => {
  return (
    <Button
      component="label"
      variant="outlined"
      className="MuiButton-download"
      startIcon={<AttachFileIcon />}
      onClick={onClick}
    >
      {name}
      {/* <VisuallyHiddenInput type="file" onChange={(event) => download} /> */}
    </Button>
  );
};

export default ButtonUploadFile;
